<template>
  <div>
    <v-app-bar
      class="header"
      :class="{ 'header--dark': isDarkMode }"
      :flat="true"
      height="60"
      fixed
      app
    >
      <button
        v-if="isMobile"
        class="d-flex"
        @click="$store.commit('toggle', 'sidebarShow')"
      >
        <apio-icon size="24" name="menu" />
      </button>

      <v-spacer class="d-md-none" />

      <v-spacer />

      <apio-dark-light-mode-toggle class="mr-1" />

      <apio-help-button />
      <TheHeaderDropdownAccnt :dark.sync="isDarkMode" />
      <v-dialog v-model="helpDialog">
        <HelpDialog />
      </v-dialog>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "TheHeader",
  components: {
    ApioHelpButton: () => import("@/components/Misc/HelpButton"),
    TheHeaderDropdownAccnt: () => import("./TheHeaderDropdownAccnt"),
    HelpDialog: () => import("@/components/Help/HelpDialog.vue"),
    ApioDarkLightModeToggle: () =>
      import("@/components/Misc/DarkLightModeToggle.vue"),
  },
  computed: {
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    helpShown() {
      return this.$store.state.mode.helpEnabled;
    },
    helpDialog: {
      get() {
        return this.$store.state.mode.helpShown;
      },
      set() {
        this.$store.commit("toggle", "helpShown");
      },
    },
  },
  methods: {
    toggleDarkTheme() {
      this.$store.commit("toggle", "darkMode");
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  z-index: 5;
}
::v-deep .v-toolbar__content {
  padding: 14px 16px;
  @media screen and (max-width: 768px) {
    padding: 10px 20px;
  }
}

.newversion {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
